module.exports = __webpack_public_path__ + "img/dynamic-12.3839facd.png";